import { useSelector } from 'react-redux';

import { ISignal, selectSignalRState } from './signalrSlice';

export const useSignalRState = (): ISignal | undefined => useSelector(selectSignalRState);
